import {
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
    Route
} from "react-router-dom"
//import "./App.css"
import Layout from "./layout/Layout"
import Home from "./pages/Home"
import Products from "./pages/Products"
import ProductDetails from "./pages/ProductDetails"
import Booking from "./pages/Booking"
//import Blog from "./pages/Blogs"
//import BlogDetails from "./pages/BlogDetails"
import Contacts from "./pages/Contacts"
import NotFound from "./pages/NotFound"
//import About from "./pages/About"
import Admin from "./pages/Admin"

let details = navigator.userAgent;
    let regexp = /android|iphone|kindle/i;
    let isMobileDevice = regexp.test(details);
    let device

    if (isMobileDevice) {
            device = "phone" ;
         } else {
            device = "desktop" ;
         }

const router = createBrowserRouter(createRoutesFromElements(
    <Route
        path="/"
        element= {<Layout device = {device}/>}
        errorElement= {<NotFound />}
    >


      <Route
        index
        element={<Home device = {device}/>}
      />

      <Route
        path="/products"
        element={<Products device={device} />}
      />
      
      <Route path="/products/:id" element={<ProductDetails />} />

      <Route
        path="/booking"
        element={<Booking device={device} />}
      />

      {/*<Route
        path="/about"
        element={<About device = {device}/>}
      />*/}
      
     {/*<Route
       path="/blog"
       element={<Blog device = {device}/>}
    />

          <Route path="blog/:blog" element = {<BlogDetails/>} />
*/}
    <Route
        path="/contacts"
        element={<Contacts device = {device}/>}
    />

    <Route
        path="/rohitBhansalib77"
        element={<Admin device = {device}/>}
    />
   
    </Route>
  ))

    export default function App() {
      return (
        <>
          <RouterProvider router={router}/>
        </>
      )
    }
